const MIN_PSI = 20
const MAX_PSI = 120
const MIN_TORQUE = 50
const MAX_TORQUE = 200

export { MIN_PSI, MAX_PSI, MIN_TORQUE, MAX_TORQUE }
